import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CategoriaModel } from '../../models/categoria.Model';
import { LoadFileModel } from '../../models/LoadFile.Model';
import { async } from 'rxjs';

@Component({
  selector: 'app-load-files',
  templateUrl: './load-files.component.html',
  styleUrls: ['./load-files.component.css']
})
export class LoadFilesComponent implements OnInit {
  categorias: CategoriaModel;
  public loadfileform: FormGroup;
  public ListarCategorias: CategoriaModel[];
  public ItemMethod: CategoriaModel;
  public ListaArchivos: FileList;
  ArchivosB64 = [];
  ArchivosNombre = [];

  public loadFile: LoadFileModel[];

  constructor(private http: HttpClient, private router: Router
  ) {

  }

  ngOnInit() {
    this.comenzar();
    this.ListaCategorias();
    this.loadForm();
  }


  public comenzar(): void {
    var soltar = document.getElementById("zonadestino");
    /* var BuscarArchivo = document.getElementById("idfile");   */

    soltar.addEventListener("dragenter", function (e) {
      e.preventDefault();
    }, false);

    soltar.addEventListener("dragover", function (e) {
      e.preventDefault();
    }, false);

    var listado = "";

    soltar.addEventListener("drop", async (e) => {
      e.preventDefault();
      this.ListaArchivos = e.dataTransfer.files;

      var datosArchivos = [];
      var datosNombreFile = [];

      for (var f = 0; f < this.ListaArchivos.length; f++) {
        var strarchivo = await this.getBase64(this.ListaArchivos[f]).then(x => x);
        datosArchivos.push(strarchivo);
        datosNombreFile.push(this.ListaArchivos[f].name);

        listado += "<b>Archivo : </b>" + this.ListaArchivos[f].name + " <b>Peso :</b> " + (this.ListaArchivos[f].size / 1024).toFixed(2) + " <b>Tipo :</b> " + this.ListaArchivos[f].type + "</br>";
      }
      this.ArchivosB64 = this.ArchivosB64.concat(datosArchivos);
      this.ArchivosNombre = this.ArchivosNombre.concat(datosNombreFile);

      var salida = document.getElementById("txtSalida");

      salida.innerHTML = listado + "<br/>";

    }, false);

    const BuscarArchivo = document.getElementById("idfiles");

    BuscarArchivo.addEventListener('change', async (event: Event) => {
      event.preventDefault();
      const input = event.target as HTMLInputElement;
      //this.ListaArchivos = this.ListaArchivos+input.files;

      
      var loadArchivo = [];
      var namefile = [];

      for (var t = 0; t < input.files.length; t++) {
        // this.ListaArchivos.push( input.files[t] );
        var archivo = input.files[t];
        var strarchivo = await this.getBase64(archivo).then(x => x);
        loadArchivo.push(strarchivo);
        namefile.push(archivo.name);
      }
      this.ArchivosB64 = this.ArchivosB64.concat(loadArchivo);
      this.ArchivosNombre = this.ArchivosNombre.concat(namefile);

    }, false);
  }

  private getRequestUrl(controller, action) {
    return `${window.location.origin}/api/${controller}/${action}`;
  }

  public async ListaCategorias() {
    const url = this.getRequestUrl("CargaArchivo", "ListaCategorias");

    let response = await this.http.post<CategoriaModel>(url, null)
      .toPromise()
      .catch(ex => {
        var error = ex.error.serverError ? ex.error.serverError : ex.message;
        console.log(error);
        return null;
      });

    if (!response) return;

    this.ListarCategorias = response;
  }

  async serv_LoadFiles(item: LoadFileModel) {
    const url = this.getRequestUrl("CargaArchivo", "UploadFile");

    const body = { ObjectRequest: JSON.stringify(item) };
    let response = await this.http.post<object>(url, body)
      .toPromise()
      .catch(ex => {
        var error = ex.error.serverError ? ex.error.serverError : 'error';
        alert("Ocurrio un error" + error);
        return null;
      });

    if (!response) return;
    this.router.navigate(['load-files']);
  }

  loadForm(): void {
    this.loadfileform = new FormGroup({
      Fc_idCategoria: new FormControl('', Validators.required),
    });
  }

  async onFormSubmit() {
    if (this.loadfileform.invalid) {
      console.log("Hay Errores .");
      return;
    }

    debugger



    for (var f = 0; f < this.ArchivosB64.length; f++) {
      let rootObject = new LoadFileModel();
      rootObject.categoriaArchivo = this.loadfileform.get('Fc_idCategoria').value;
      rootObject.idUsuario = 23;
      rootObject.archivoB64 = this.ArchivosB64[f];
      rootObject.nombreArchivo = this.ArchivosNombre[f];
      await this.serv_LoadFiles(rootObject);
    }

    if (this.ArchivosB64.length > 0) {
      alert("Se cargaron " + this.ArchivosB64.length+" Archivos.");
    }


  }
  async getBase64(file) {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.toString());
        reader.onerror = error => reject(error);
      });
    } catch (error) {
      console.log(error);
    }
  }

}
